import { render, staticRenderFns } from "./Artdea.vue?vue&type=template&id=806d8e4e"
import script from "./Artdea.vue?vue&type=script&lang=js"
export * from "./Artdea.vue?vue&type=script&lang=js"
import style0 from "./Artdea.vue?vue&type=style&index=0&id=806d8e4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports